import { buildWhatsAppLink } from "../lib/constants";

export default function FloatingWhatsApp({ message }) {
  return (
    <a
      href={buildWhatsAppLink(message)}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-button"
      aria-label="Chat WhatsApp Admin"
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-[99] flex items-center gap-3 group"
    >
      <span className="hidden sm:inline-flex items-center bg-[#0a0a0a] border border-[#262626] text-white text-xs font-bold uppercase tracking-widest px-3 py-2 group-hover:border-[#25D366] group-hover:text-[#25D366] transition-colors">
        Chat Admin
      </span>
      <span className="relative w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] flex items-center justify-center shadow-[0_0_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform">
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-50 animate-ping pointer-events-none" />
        <svg
          viewBox="0 0 32 32"
          fill="white"
          className="w-7 h-7 relative z-10"
          aria-hidden="true"
        >
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.612 3.41 4.42 4.64.71.487 2.337 1.504 3.198 1.504.42 0 .823-.116 1.16-.302.515-.288.99-.832 1.117-1.418.058-.244.058-.487.058-.745 0-.13-.029-.215-.115-.273-.13-.058-2.21-1.103-2.495-1.218zM16.005 30c-7.733 0-13.999-6.267-13.999-14C2.006 8.267 8.273 2 16.006 2c7.733 0 14 6.267 14 14 0 7.733-6.267 14-14 14zm7.84-22.7c-2.097-2.094-4.886-3.262-7.834-3.262-6.117 0-11.083 4.965-11.083 11.083 0 1.954.515 3.864 1.505 5.55l-1.6 5.853 5.997-1.575c1.617.872 3.466 1.345 5.181 1.345h.014c6.117 0 11.083-4.967 11.083-11.083 0-2.948-1.146-5.738-3.246-7.834z" />
        </svg>
      </span>
    </a>
  );
}
